import { Pipe, PipeTransform } from '@angular/core';
import { IArticle } from '../../prisma-xs/models/article.model';

@Pipe({
    name: 'sameHeightAsEnclosure',
    standalone: false
})
export class SameHeightEnclosurePipe implements PipeTransform {

  transform(article: IArticle, enclosureHeight: number): boolean {
    return article.widget.height === enclosureHeight;
  }

}
